var _desc, _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProductIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "52px",
    height: "52px",
    viewBox: "0 0 52 52",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null)), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Desktop",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }, /*#__PURE__*/React.createElement("g", {
    id: "remark/3.1.1-\\u623F\\u8CB8\\u7522\\u54C1-\\u5167\\u9801",
    transform: "translate(-731.000000, -565.000000)",
    stroke: "#A17D58"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Stacked-Group-2",
    transform: "translate(220.000000, 566.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-11"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-7",
    transform: "translate(512.000000, 0.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M39.516129,7.25806452 C39.516129,11.2669355 36.2669355,14.516129 32.2580645,14.516129 C28.2491935,14.516129 25,11.2669355 25,7.25806452 C25,3.24919355 28.2491935,0 32.2580645,0 C36.2669355,0 39.516129,3.24919355 39.516129,7.25806452 Z",
    id: "Stroke-1"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M47.5806452,19.3548387 C47.5806452,20.691129 46.4975806,21.7741935 45.1612903,21.7741935 C43.825,21.7741935 42.7419355,20.691129 42.7419355,19.3548387 C42.7419355,18.0185484 43.825,16.9354839 45.1612903,16.9354839 C46.4975806,16.9354839 47.5806452,18.0185484 47.5806452,19.3548387 Z",
    id: "Stroke-3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M45.1612903,21.7741935 C49.1935484,21.7741935 50,19.3548387 50,19.3548387",
    id: "Stroke-5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M41.9354839,25 C41.9354839,25 47.5806452,25.8064516 47.5806452,19.3548387",
    id: "Stroke-7"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.7419355,20.1612903 L29.0322581,20.1612903",
    id: "Stroke-9"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.7745968,12.1818548 C20.3802419,12.3237903 19.0415323,12.6197581 17.7423387,12.903629 C16.1294355,9.67782258 11.2907258,8.87137097 8.06491935,9.67782258 L9.67782258,16.9358871 C7.48991935,18.9576613 5.52217742,22.2592742 4.8391129,25.8068548 L0.000403225807,25.0004032 L0.806854839,35.4842742 L4.8391129,34.6778226 C5.86572581,39.0165323 8.83185484,42.3971774 12.0971774,44.3552419 L11.2907258,50.0004032 L19.3552419,50.0004032 L19.3552419,46.7745968 C19.3552419,46.7745968 23.3875,47.5810484 27.4197581,46.7745968 L27.4197581,50.0004032 L35.4842742,50.0004032 L34.6778226,44.3552419 C39.0826613,41.7133065 41.9358871,36.928629 41.9358871,29.8391129 C41.9358871,24.6294355 40.4633065,20.6189516 37.903629,17.7423387",
    id: "Stroke-11"
  })))))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProductIcon2);
export default __webpack_public_path__ + "static/media/product-icon2.f7a68f08f4791948c689e4640c68160e.svg";
export { ForwardRef as ReactComponent };